module.exports = __webpack_public_path__ + "img/bg.751573dd.png";